export default Object.freeze({
  Yes: 1,
  No: 2,
  Unknown: 3,
});
